import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { Provider } from "react-redux";
import store from "./redux/store";

const decode = (val) => {
  try {
    return atob(val);
  } catch {
    return val;
  }
};
// Google Analytics after page load
const loadGtag = () => {
  const gtagScript = document.createElement("script");
  const gtagId = decode(window._env_?.GTAG_ID);
  gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${gtagId}`;
  gtagScript.async = true;
  document.head.appendChild(gtagScript);

  gtagScript.onload = () => {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag; // optional: attach globally for React usage
    gtag("js", new Date());
    gtag("config", gtagId);
  };
};

// Wait for full page load
if (document.readyState === "complete") {
  loadGtag();
} else {
  window.addEventListener("load", loadGtag);
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <App />
  </Provider>
);
